import { isValidElement, useSyncExternalStore, type HTMLAttributeAnchorTarget, type MouseEventHandler, type ReactNode } from 'react';

export type NotificationAlertStep = {
	message: ReactNode;
	actionLabel?: ReactNode;
	suffix?: ReactNode;
	href?: string;
	icon?: ReactNode;
	onClick?: MouseEventHandler<HTMLElement>;
	target?: HTMLAttributeAnchorTarget;
	rel?: string;
};

export type NotificationAlertInput = ReactNode | NotificationAlertStep;

type Registro = NotificationAlertStep & { id: string };

let avisos: Registro[] = [];
let contador = 0;

const listeners = new Set<() => void>();
const notify = () => listeners.forEach((l) => l());

const subscribe = (l: () => void) => {
	listeners.add(l);
	return () => {
		listeners.delete(l);
	};
};

const getAvisos = () => avisos;

const ehPasso = (aviso: NotificationAlertInput): aviso is NotificationAlertStep =>
	typeof aviso === 'object' && aviso !== null && !isValidElement(aviso) && !Array.isArray(aviso) && 'message' in aviso;

export function addNotification(aviso: NotificationAlertStep, opcoes?: { id?: string }): () => void;
export function addNotification(aviso: ReactNode, opcoes?: { id?: string }): () => void;
export function addNotification(aviso: NotificationAlertInput, opcoes?: { id?: string }): () => void;
export function addNotification(aviso: NotificationAlertInput, opcoes?: { id?: string }) {
	const id = opcoes?.id ?? `notification-alert-${++contador}`;
	const passo = ehPasso(aviso) ? aviso : { message: aviso };

	avisos = [...avisos.filter((a) => a.id !== id), { ...passo, id }];
	notify();

	return () => removeNotification(id);
}

export function removeNotification(id: string) {
	const restantes = avisos.filter((a) => a.id !== id);
	if (restantes.length === avisos.length) return;

	avisos = restantes;
	notify();
}

export function useNotifications() {
	return useSyncExternalStore(subscribe, getAvisos, getAvisos);
}
